export default {
  d: "M50,34.6V120H15V0h35V34.6l20,0.2V0h35v120H70V34.8L50,34.6z",
  viewBox: "0 0 120 120"
}
